import Smartlook from 'smartlook-client'
import { UserWithMeta, allUserMetaSchema } from 'src/common-services'
import { IS_PROD } from 'src/config'

const enabled = IS_PROD

export const initSmartlook = () => {
  if (!enabled) {
    return
  }

  Smartlook.init('29c4169725ade3af2cd682795758a7288d11ba7a')
}

export const identifyUser = (user: UserWithMeta) => {
  if (!enabled) {
    return
  }

  const meta = allUserMetaSchema.parse(user)
  const name = `${meta?.firstName ?? ''} ${meta?.lastName ?? ''}`.trim()
  Smartlook.identify(user.id, {
    email: user.email,
    name,
  })
}

export const anonymize = () => {
  if (!enabled) {
    return
  }

  Smartlook.anonymize()
}
